const PRODUCTS = [
  'items',
  'items/:id',
  'items/:id/variants/:vid',
  'collections',
  'collections/:id',
  'catalog-tuning',
  'reviews',
  'imports',
  'imports-products/new',
];

export default PRODUCTS;
